import { createAsyncThunk } from '@reduxjs/toolkit';
import { getFeeds } from '../../../api/feeds';
import { createRequest } from '../../../helpers/api/createRequest';

export const GET_FEEDS = 'feeds/getFeeds';

export const getFeedsThunk = createAsyncThunk(
    GET_FEEDS,
    createRequest({
        type: GET_FEEDS,
        loader: async () => getFeeds(),
    }),
);
